import Head from 'next/head';
import propTypes from 'prop-types';
import React from 'react';
import * as theme from '../constants/theme';
import {Browser, Header, Footer} from '.';

const {ACCENT_LIGHT, BACKGROUND, BACKGROUND_WHITE, GUTTER, SMALL_GUTTER, TEXT, TEXT_WHITE, TITLE} = theme;

const Layout = ({children, mainMenu}) => (
	<div className='wrapper'>
		<Head>
			<meta charSet='utf-8'/>
			<meta name='viewport' content='initial-scale=1.0, width=device-width'/>
			<link rel='icon' href='/static/favicon.ico'/>
			<title>{TITLE}</title>
			<meta name='description' content='LP Vent AB, Ventilations firma med fulla behörigheter i Ulricehamn.'/>
		</Head>
		<style jsx global>
			{`
				@import url('https://rsms.me/inter/inter-ui.css');

				* {
					box-sizing: border-box;
				}

				html {
					color: ${TEXT};
					font-family: 'Inter UI', sans-serif;
					-webkit-font-smoothing: antialiased;
				}

				body,
				blockquote,
				dl,
				dd,
				h1,
				h2,
				h3,
				h4,
				h5,
				h6,
				figure,
				p,
				pre {
					margin: 0;
				}

				ol,
				ul {
					list-style: none;
					margin: 0;
					padding: 0;
				}

				a {
					text-decoration: none;
					color: ${TEXT};
					font-weight: bold;
				}

				a:active,
				a:hover {
					outline-width: 0;
					color: ${TEXT};
					text-decoration: underline;
				}

				h1 {
					font-size: 2em;
					line-height: 1.25em;
				}

				h2 {
					font-size: 1.625em;
					line-height: 1.15384615em;
				}

				h3 {
					font-size: 1.375em;
					line-height: 1.13636364em;
				}

				@media (min-width: 48em) {
					h1 {
						font-size: 3em;
						line-height: 1.25em;
					}

					h2 {
						font-size: 2.25em;
						line-height: 1.25em;
					}

					h3 {
						font-size: 1.75em;
						line-height: 1.25em;
					}
				}

				img,
				video {
					max-width: 100%;
					height: auto;
					vertical-align: middle;
				}

				button {
					background: transparent;
					border: 0;
					padding: 0;
				}

				button:focus,
				[tabindex="-1"]:focus {
					outline: none !important;
				}

				.Button {
					background: transparent;
					border-radius: 0;
					border-style: solid;
					box-sizing: border-box;
					display: inline-block;
					margin: 0;
					position: relative;
					text-align: center;
					text-decoration: none;
					user-select: none;
					padding: calc(10px * 1.5) 30px;
					border-radius: 0;
					border: 0;
					transition: all 0.15s ease-out;
					letter-spacing: 1px;
					text-transform: uppercase;
				}

				.Button--black,
				.Button--black:hover {
					color: ${TEXT_WHITE}
					background-color: ${BACKGROUND};
				}

				.Page-title {
					padding-bottom: 1em;
				}

				.wrapper {
					display: flex;
					flex-direction: column;
					min-height: 100vh;
				}

				main {
					flex: 1 0 auto;
					padding: 0;
					padding-top: 110px;
					background-color: ${BACKGROUND_WHITE};
				}

				.SiteWrapper {
					position: relative;
					overflow: hidden;
					width: 100%;
				}

				.Excerpt-container {
					padding: ${SMALL_GUTTER};
					width: 100%;
					height: 100%;
					background-color: ${ACCENT_LIGHT};
				}

				.Excerpt-image {
					height: 100%;
				}

				.Excerpt-image img {
					width: 100%;
					height: 100%;
					max-width: none;
				}

				.Excerpt-article {
					padding: ${SMALL_GUTTER};
				}

				.Excerpt-article--center {
					text-align: center;
				}

				.Excerpt-article--borderTop {
					border-top: 2px solid ${TEXT};
					margin-top: ${GUTTER};
				}

				.Excerpt-article h2 {
					line-height: 1.6em;
					text-transform: uppercase;
				}

				.List {
					padding: 10px 0;
				}

				.List-item {
					padding: 5px;
				}

				.Contact-list {
					display: flex;
					flex-flow: column;
					padding: 20px 0;
				}

				.Contact-list > li {
					padding: 20px 20px 20px 0;
				}

				.Contact-list > li span {
					display: block;
				}

				.Subsection {
					padding: 20px 0;
				}

				@media (min-width: 48em) {
					.Contact-list {
						flex-flow: row nowrap;
					}

					.Contact-list > li {
						padding: 20px;
					}

					.Contact-list > li:first-of-type {
						padding-left: 0;
					}
				}

				.Container {
					display: flex;
					flex-flow: row wrap;
				}

				.Box {
					display: flex;
				}

				.Box-half {
					flex: 1 1 100%;
				}

				.Box-full {
					flex: 1 1 100%;
				}

				.Box > * {
					flex: 1 1 100%;
				}

				@media (min-width: 48em) {
					.Box-half {
						flex: 1 1 50%;
					}
				}
			`}
		</style>
		<Browser/>
		<Header mainMenu={mainMenu}/>
		<main>{children}</main>
		<Footer/>
	</div>
);

Layout.propTypes = {
	children: propTypes.any,
	mainMenu: propTypes.array
};

export default Layout;



// WEBPACK FOOTER //
// components/layout.js